import AnamnesiFamiliareEdit from "./components/GastroAnamnesiFamiliareEdit.vue"
import AnamnesiFamiliareView from "./components/GastroAnamnesiFamiliareView.vue"
import AnamnesiFamiliareList from "./components/GastroAnamnesiFamiliareList.vue"

export default{
    AnamnesiFamiliareEdit,
    AnamnesiFamiliareView,
    AnamnesiFamiliareList
}